export const FETCH_APP_BC_SIGNUP_GRAPH_REQUEST = 'FETCH_APP_BC_SIGNUP_GRAPH_REQUEST';
export const FETCH_APP_BC_SIGNUP_GRAPH_SUCCESS = 'FETCH_APP_BC_SIGNUP_GRAPH_SUCCESS';
export const FETCH_APP_BC_SIGNUP_GRAPH_ERROR   = 'FETCH_APP_BC_SIGNUP_GRAPH_ERROR';

export const FETCH_APP_BC_PRODUCT_GRAPH_REQUEST = 'FETCH_APP_BC_PRODUCT_GRAPH_REQUEST';
export const FETCH_APP_BC_PRODUCT_GRAPH_SUCCESS = 'FETCH_APP_BC_PRODUCT_GRAPH_SUCCESS';
export const FETCH_APP_BC_PRODUCT_GRAPH_ERROR   = 'FETCH_APP_BC_PRODUCT_GRAPH_ERROR';
